import { z } from "zod";
import { namespaceSchema, nanoidSchema, slugSchema } from "../../utility/index.js";
import { nanoid } from "nanoid";
const referenceManagedDocSchema = z.object({
  /** API namespace */
  namespace: namespaceSchema,
  /** API slug */
  slug: slugSchema,
  /** Selected versions to display */
  versions: z.string().array().default(["latest"])
});
const referenceSchema = z.object({
  /** Unique identifier for the reference */
  uid: nanoidSchema,
  /** Title of the reference */
  title: z.string().transform((val) => val === "" ? "Reference" : val),
  /** Description of the reference */
  description: z.string(),
  /** Yjs reference id for the reference */
  yjsReference: nanoidSchema,
  /** Config for the reference */
  config: z.string().default("{}"),
  /** Optional permalink for the reference */
  specPermalink: z.string().default(""),
  /** Optional registry API */
  managedDoc: referenceManagedDocSchema.nullable().default(null),
  /** Whether to publish the reference or not */
  show: z.boolean().default(true),
  /** Option to show the header link as a button */
  isButton: z.boolean().default(false),
  /** Option to force the header link to the top nav */
  isStarred: z.boolean().default(false)
});
function defaultReference() {
  return referenceSchema.parse({
    uid: nanoid(),
    title: "",
    description: "",
    yjsReference: nanoid()
  });
}
export {
  defaultReference,
  referenceManagedDocSchema,
  referenceSchema
};
//# sourceMappingURL=reference.js.map
